<template>

        <div id="footerdefaultdiv" class="horizFlex">
            <img alt="school logo" :src="badgeIcon_footer"  class="logofooter" >
            <div class="vertFlexLeft">
                <label class="foottext_front" v-if="currentNav=='front'">{{footLinkText_front}}</label>
                <label class="foottext_back" v-if="currentNav=='back'">{{footLinkText_back}}</label>
            </div>
        </div>
  
  </template>
  
  <script>
  import smallbutton from '../controls/button.vue'
  import linkbutton from '../controls/linkbutton.vue'
  import {mapFields} from 'vuex-map-fields'
  import badge from '../../services/badge.js'
  import style from '../../style.js'
  export default {
      components:{
          smallbutton,
          linkbutton
      },
      name:"footer_default",
      mixins:[style, badge],
      props:{
           
      },
      data(){
          return{
              
          }
      },
      computed:{
        ...mapFields([
            'badgeData',
            'imageBasePath',
            'BadgeDesign',
        ]),
      },
      methods:{
          
      }
  }
  </script>
  
  <style>

  </style>



